module.exports = __webpack_public_path__ + "static/media/wave.ea79f27d.svg";